import axios from "axios";

// Use the SAME origin the user is on (www.saamne.com or saamne.com or preview host).
// This avoids cross-origin redirects (e.g. apex 308 → www) which break preflight CORS.
// REACT_APP_BACKEND_URL is honoured ONLY when its origin matches the current page
// (useful in non-browser/SSR or unit tests). Falls back to relative "/api" otherwise.
const envBackend = process.env.REACT_APP_BACKEND_URL || "";
let API = "/api";
if (typeof window !== "undefined") {
  try {
    if (envBackend && new URL(envBackend).origin === window.location.origin) {
      API = `${envBackend.replace(/\/+$/, "")}/api`;
    }
  } catch {
    /* malformed env URL — stick with relative */
  }
} else if (envBackend) {
  // SSR / build-time only
  API = `${envBackend.replace(/\/+$/, "")}/api`;
}
export { API };

export const api = axios.create({ baseURL: API });

export function getVisitorId() {
  let id = localStorage.getItem("saamne_visitor_id");
  if (!id) {
    id = `v_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;
    localStorage.setItem("saamne_visitor_id", id);
  }
  return id;
}

export function getInterestedSet() {
  try {
    return new Set(JSON.parse(localStorage.getItem("saamne_interested") || "[]"));
  } catch {
    return new Set();
  }
}

export function markInterestedLocal(eventId) {
  const s = getInterestedSet();
  s.add(eventId);
  localStorage.setItem("saamne_interested", JSON.stringify([...s]));
}

export function getAdminToken() {
  return localStorage.getItem("saamne_admin_token") || "";
}

export function setAdminToken(t) {
  localStorage.setItem("saamne_admin_token", t);
}
